import { render } from "./ActivityCollapse.vue?vue&type=template&id=a9af1b0e"
import script from "./ActivityCollapse.vue?vue&type=script&lang=js"
export * from "./ActivityCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__